.markdown-content {
  --text-fz: var(--mantine-font-size-sm);
  padding: var(--mantine-spacing-sm);
  font-size: var(--text-fz);
  > :first-child {
    padding-block-start: 0;
    margin-block-start: 0;
  }
  > :last-child {
    padding-block-end: 0;
    margin-block-end: 0;
  }
}
